import { registerTransfer } from './registerTransfer';

type ApiDeclaration = {
    registerTransfer: typeof registerTransfer;
};

export const card2cardApiDeclaration: ApiDeclaration = {
    registerTransfer
};
